<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <div class="col-sm-12">
        <h1>MUNKALAPOK</h1>
          <div v-if="userType=='admin' || userType=='user'" class="col-sm-2">
            <!-- // NEW -->
            <b-button
              size="sm"
              variant="primary"
              class="btn float-left"
              @click="$router.push({ name: 'Calculator' })"
              ><b-icon-plus-circle></b-icon-plus-circle>
              Új munkalap hozzáadása
            </b-button>
          </div>
          <div class="row">

          <!-- // SEARCH INPUT -->
          <div class="col-sm-6">
            <b-button-group>
              <div>
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="outline-danger"
                  @click="searchText='', filterSelect='', statusListSelect='', fromDate='', toDate='', archiv=0, search()"
                  ><b-icon-x-circle></b-icon-x-circle>
                </b-button>
              </div>
              <div>
                <b-form-select
                  size="sm"
                  v-model="filterSelect"
                  :options="filters"
                  class="form-control"
                  id="td"
                  required
                ></b-form-select>
              </div>
              <div>
                <b-form-input
                  size="sm"
                  class="form-control"
                  ref="searchInput"
                  v-model="searchText"
                  id="search"
                  placeholder="Keresőszó"
                ></b-form-input>
              </div>
              <div>
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="success"
                  @click="statusListSelect='', fromDate='', toDate='', archiv=0, search()"
                  ><b-icon-search></b-icon-search>
                  Keresés
                </b-button>
              </div>
              <!-- <div> -->
                <!-- // EXCEL EXPORT-->
                <!-- <b-button
                  size="sm"
                  class="btn ml-20"
                  variant="warning"
                  @click="tableToExcel('table', 'Anyagtípusok')"
                  ><b-icon-download></b-icon-download>
                  Excel export
                </b-button> -->
              <!-- </div> -->
            </b-button-group>
          </div>

          <div class="col-sm-6">
            <b-button-group>
              <div>
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="outline-danger"
                  @click="searchText='', filterSelect='', statusListSelect='', fromDate='', toDate='', archiv=0, search()"
                  ><b-icon-x-circle></b-icon-x-circle>
                </b-button>
              </div>
              <div>
                <b-form-select
                  size="sm"
                  v-model="statusListSelect"
                  :options="statusList"
                  class="form-control"
                  id="Std"
                  required
                ></b-form-select>
              </div>
              <div>
                <b-form-input
                  size="sm"
                  class="form-control"
                  v-model="fromDate"
                  id="fromDate"
                  placeholder="Kezdődátum"
                  type="date"
                ></b-form-input>
              </div>
              <div >
                <b-form-input
                  size="sm"
                  class="form-control"
                  v-model="toDate"
                  id="toDate"
                  placeholder="Végdátum"
                  type="date"
                ></b-form-input>
              </div>
              <div>
                <b-button
                  size="sm"
                  class="btn float-left"
                  variant="success"
                  @click="searchText='', filterSelect='', searchStatus()"
                  ><b-icon-search></b-icon-search>
                  Keresés státuszra
                </b-button>
              </div>
              <div style="margin-left: 5px; margin-top: 3px;;">
                  <b-form-checkbox
                    id="archiv"
                    v-model="archiv"
                    name="archiv"
                    value="1"
                    unchecked-value="0"
                  >
                    Archív
                  </b-form-checkbox>
              </div>
              <!-- <div>
                <b-button
                  size="sm"
                  class="btn ml-20"
                  variant="warning"
                  @click="statToExcel('table', 'Státusz_Statisztika')"
                  ><b-icon-download></b-icon-download>
                  Stat
                </b-button>
              </div> -->
            </b-button-group>
          </div>

        </div>

      </div>
<!-- 
      <div class="mt-3" >
        <table ref="statListTable" class="labelsize table-striped text-right">
          <thead>
            <tr>
            <th>1</th>
            <th>2</th>
            <th>3</th>
            <th>4</th>
            <th>5</th>
            </tr>
          </thead>
          <tbody group="people" :list="statList" tag="tbody">
            <tr v-for="(element) in list" :key="element.munkaId">
              <td><p>{{element.munkaId}}</p></td>
              <td><p>{{element.logCreated}}</p></td>
              <td><p>{{element.statuslogId}}</p></td>
              <td><p>{{element.statusName}}</p></td>
              <td><p>{{element.satusId}}</p></td>
            </tr>
          </tbody>
        </table>
      </div> -->

      <!-- // EXCEL EXPORT -->
      <div class="mt-3" hidden>
        <table ref="listTable" class="labelsize table-striped text-right">
          <thead>
            <tr>
            <th>id</th>
            <th>Kelt dátum</th>
            <th>MiniCRM adatlap neve</th>
            <th>Kat</th>
            <th>K</th>
            <th>Státusz</th>
            <th>Megjegyzés</th>
            <th>Végösszeg</th>
            <th>Ajánlat</th>
            </tr>
          </thead>
          <tbody group="people" :list="list" tag="tbody">
            <tr  v-for="(element) in list" :key="element.id">
              <td><p>{{element.id}}</p></td>
              <td><p class="nowrap1">{{element.created}}</p></td>
              <td><p class="nowrap2">{{element.partner}}</p></td>
              <td><p class="nowrap3">{{element.partnerkategoria}}</p></td>
              <td><p class="nowrap3">{{element.kiallito}}</p></td>
              <td><p class="nowrap3">{{element.statusnev}}</p></td>
              <td><p class="nowrap3">{{element.megjegyzes}}</p></td>
              <td><p class="nowrap3">{{element.vegosszeg}}</p></td>
              <td><p class="nowrap3">{{element.vegosszeg}}</p></td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="list" :fields="fields" :key="list.id">

          <!-- // PDF -->
          <template v-slot:cell(munkalap)="row" class="mb-1">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="
                $router.push({
                  name: 'Munkalap',
                  params: { id: row.item.id }
                })
              "
              class="mr-0"
              >
              <img style="width: 14px;" src="../assets/pdf-icon.png" alt="">
            </b-button>
          </template>

          <!-- // PRINT PDF -->
          <template v-slot:cell(print)="row" class="mb-1">
            <b-button
              size="sm"
              variant="outline-primary"
              @click="printPDF(row.item.id)"
              class="mr-0"
              >
              <b-icon-printer></b-icon-printer>
            </b-button>
          </template>

          <!-- // EDIT -->
          <template v-if="userType=='admin' || userType=='user'" v-slot:cell(edit)="row">
            <b-button v-if="row.item.closed != 1"
              size="sm"
              @click="
                $router.push({
                  name: 'Calculator',
                  params: { id: row.item.id }
                })
              "
              variant="outline-success"
              class="mr-0"
            ><b-icon-pencil></b-icon-pencil>
            </b-button>
          </template>

          <!-- // CSV EXPORT -->
          <template v-slot:cell(csv)="row">
            <b-button
              size="sm"
              variant="outline-secondary"
              class="mr-0"
              :disabled="csvExportingId === row.item.id"
              @click="exportWorkToCsv(row.item.id)"
              title="CSV export"
            >
              <b-icon-download></b-icon-download>
            </b-button>
          </template>

          <!-- // MINICRM LINK -->
          <template v-slot:cell(emaillink)="row" class="mb-1">
            <b-button
              size="sm"
              @click="redirect(row.item.emaillink)"
              variant="outline-danger"
              class="mr-1"
              >
              LINK
            </b-button>
          </template>

          <!-- // MINICRM DATUM
          <template v-slot:cell(created)="row" class="mb-1">
            <b-button
              size="sm"
              style="width: 100px"
              >
              {{row.item.created}}
            </b-button>
          </template> -->

          <!-- // DELETE -->
          <template v-if="userType=='admin'" v-slot:cell(del)="row" class="mb-1">
            <b-button
              size="sm"
              @click="showMsgBoxTwo(row.item.id, row.item.partner)"
              variant="outline-danger"
              class="mr-1"
              ><b-icon-trash></b-icon-trash>
            </b-button>
          </template>
        </b-table>
      </div>
    </b-card>

    <!-- // PDF GENERATE -->
    <div>
      <vue-html2pdf
        :show-layout="false"
        :float-layout="true"
        :enable-download="true"
        :preview-modal="true"
        :paginate-elements-by-height="1400"
        filename = "brandmax-ajánlat"
        :pdf-quality="2"
        :manual-pagination="false"
        pdf-format="a5"
        pdf-orientation="landscape"
        pdf-content-width="800px"
        @hasStartedGeneration="hasStartedGeneration()"
        @hasGenerated="hasGenerated($event)"
        ref="html2Pdf"
    >
        <section slot="pdf-content">

          <!-- PDF Content Here -->
          <div class="container-fluid" style="background-white: aliceblue; width: 800px;">

            <!-- MUNKALAP TABÁLÁZAT -->
            <div class="row fluid mytext-x-small">
              <div class="col-sm-12 ">
                  {{myTempAnyagTipus.kelt}} _ {{myTempAnyagTipus.kiallitotta}} __ ID: {{myTempAnyagTipus.mymunkaid}} __ {{myTempAnyagTipus.partner}}
              </div>
            </div>
            <table class="table tablepdf small hovered col-sm-12 munkalap-pdf-grid">
              <colgroup>
                <col style="width:200px;">
                <col style="width:45px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:250px;">
                <col style="width:70px;">
              </colgroup>
              <thead>
                <tr>
                  <th class="text-left">Azonosító (fájlnév)</th>
                  <th class="text-right">db</th>
                  <th class="text-right">cm(x)</th>
                  <th class="text-right">cm(y)</th>
                  <th class="text-right">m2</th>
                  <th class="text-right">fm</th>
                  <th class="text-right">Anyag+kivitel</th>
                  <th class="text-right">Ár</th>
                </tr>
              </thead>
            </table>

            <table class="tablepdf table small col-sm-12 munkalap-pdf-grid" v-for="(pageElement) in myTempAnyagTipus.pages" :key="pageElement.id">
              <colgroup>
                <col style="width:200px;">
                <col style="width:45px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:50px;">
                <col style="width:250px;">
                <col style="width:70px;">
              </colgroup>
              <tbody>
                <tr v-for="(pageTetel) in pageElement.tetels" :key="pageTetel.id">
                  <td class="text-left pdf-item-name">{{pageTetel.tetelnev}}</td>
                  <td class="text-right">{{pageTetel.db}}</td>
                  <td class="text-right">{{Number(pageTetel.cm1).toFixed(1)}}</td>
                  <td class="text-right">{{Number(pageTetel.cm2).toFixed(1)}}</td>
                  <td class="text-right">{{Number(pageTetel.m2).toFixed(2)}}</td>
                  <td class="text-right text-danger">{{Number(pageTetel.fm || 0).toFixed(2)}}</td>
                  <td></td>
                  <td class="text-right">{{formatDarabarDisplay(pageTetel.darabar)}}</td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <th class="text-left" colspan="4">{{pageElement.megnevezes}}</th>
                  <th class="text-right">{{parseFloat(pageElement.osszterulet, 2).toFixed(2)}}</th>
                  <th></th>
                  <td class="text-right">{{pageElement.tipusName}}</td>
                  <td class="text-right">{{pageElement.pageAr}}</td>
                </tr>
                <tr v-if="pageElement.megmunkalasid && pageElement.blockType !== 'megmunkalas'">
                  <th colspan="4"></th>
                  <th></th>
                  <th class="text-right text-danger">{{Number(pageElement.osszfm || 0).toFixed(2)}}</th>
                  <td class="text-right">{{pageElement.megmunkalasName}}</td>
                  <td class="text-right">{{pageElement.megmunkalas_ar || 0}}</td>
                </tr>
                <tr v-if="shouldShowBlockTotalRow(pageElement)">
                  <th colspan="7"></th>
                  <td class="text-right munkalap-block-total">{{ blockPageOsszeg(pageElement) }}</td>
                </tr>
              </tfoot>
            </table>

            <!-- // EGYÉB TÉTEL -->
            <table v-show="EgyebTetelekShow" class="table tablepdf small col-sm-12 mt-0 mb-0">
              <tbody>
                <tr v-for="(tetel) in myTempAnyagTipus.cikkTetels" :key="tetel.id">
                  <td style="width: 200px !important; text-align: left;" colspan="1">{{tetel.megnevezes}}</td>
                  <td style="width: 45px !important; text-align: left;" colspan="1">{{tetel.db}}</td>
                  <td style="width: 450px !important; text-align: left;" colspan="1">{{tetel.mennyisegiegyseg}}</td>
                  <td style="width: 70px !important; text-align: right;" colspan="5">{{tetel.netto * tetel.db}}</td>
                </tr>
              </tbody>
            </table>

            <!-- // VÉGÖSSZEG -->
            <table class="table tablepdf small col-sm-12 mt-0 mb-0">
              <tbody>
                <tr>
                  <td style="width: 695px !important; text-align: right;" >Számított végösszeg</td>
                  <td style="width: 70px !important; text-align: right;" >{{myTempAnyagTipus.szamitottVegOsszeg}}</td>
                </tr>
                <tr>
                  <th style="width: 695px !important; text-align: right;" >Kiajánlott ár</th>
                  <td style="width: 70px !important; text-align: right;" >{{myTempAnyagTipus.VegOsszeg}}</td>
                </tr>
              </tbody>
            </table>

            <!-- // JELMAGYARÁZAT -->
            <table class="table tablepdf small col-sm-12  mt-0 mb-0">
              <tbody>
                <tr style="mt-0">
                  <th style=" border-top-width: 0px; padding-top: 2px; padding-bottom: 2px;">{{myTempAnyagTipus.megjegyzes}}</th>
                </tr>
              </tbody>
            </table>

          </div>

        </section>
    </vue-html2pdf>
    </div>

  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'
import { calculatorUiToCsv, formatDarabarDisplay, blockPageOsszeg, shouldShowBlockTotalRow } from '../utils/munkalapCsvExport'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      dateconvert: null,
      EgyebTetelekShow: false,
      tableHeadShow: false,
      boxTwo: '',
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      filters: [
        'Minden oszlop',
        'id',
        'Dátum',
        'MiniCRM adatlap neve',
        'Kat',
        'K',
        'Státusz',
        'Megjegyzés',
        'Végösszeg'
      ],
      filterSelect: '',
      list: [],
      fields: [
        {
          key: 'id',
          label: 'Id',
          sortable: true,
          sortDirection: 'desc'
        },
        { key: 'munkalap', sortable: false },
        { key: 'edit', sortable: false },
        { key: 'csv', label: 'CSV', sortable: false },
        {
          key: 'emaillink',
          label: 'CRM',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'created',
          formatter: (value, key, item) => {
            return moment(String(value)).format('YYYY-MM-DD')
          },
          label: 'Kelt dátum',
          sortable: true,
          tdClass: 'widthDatum',
          sortDirection: 'desc'
        },
        {
          key: 'partner',
          label: 'MiniCRM adatlap neve',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'widthMinicrm',
          thClass: 'text-left'
        },
        {
          key: 'partnerkategoria',
          label: 'Kat',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'kiallito',
          label: 'K',
          sortable: true,
          sortDirection: 'desc'
        },
        {
          key: 'statusnev',
          label: 'Státusz',
          sortable: true,
          tdClass: 'widthStatus',
          sortDirection: 'desc'
        },
        {
          key: 'megjegyzes',
          label: 'Megjegyzés',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-left',
          thClass: 'text-left'
        },
        {
          key: 'vegosszeg',
          label: 'Végösszeg',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        // { key: 'send', sortable: false },
        { key: 'del', sortable: false }
      ],
      myTempAnyagTipus: [],
      searchText: '',
      statusList: [],
      statusListSelect: '',
      fromDate: '',
      toDate: '',
      archiv: '0',
      statList: [],
      csvExportingId: null,
      uri: 'data:application/vnd.ms-excel;base64,',
      template: '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urns:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
      base64: function (s) { return window.btoa(unescape(encodeURIComponent(s))) },
      format: function (s, c) { return s.replace(/{(\w+)}/g, function (m, p) { return c[p] }) }
    }
  },
  methods: {
    formatDarabarDisplay,
    blockPageOsszeg,
    shouldShowBlockTotalRow,
    downloadCsv (filename, csvText) {
      const normalized = String(csvText).replace(/\n/g, '\r\n')
      // UTF-8 BOM, hogy Excel-ben is jól jelenjen meg
      const blob = new Blob(['\ufeff' + normalized], { type: 'text/csv;charset=utf-8;' })
      const url = URL.createObjectURL(blob)
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    },
    exportWorkToCsv (id) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
        return
      }
      this.csvExportingId = id
      payload.token = this.token
      payload.userType = this.userType
      payload.id = id
      axios.post('https://' + process.env.ROOT_API + '/munkak/pdf', { payload })
        .then(res => {
          const client = res.data.client || {}
          const csv = calculatorUiToCsv(client)
          const safePartner = (client.partner || 'munkalap').toString().replace(/[\\/:*?"<>|]+/g, '_')
          this.downloadCsv(`munkalap_${id}_${safePartner}.csv`, csv)
        })
        .catch(err => {
          console.log(err)
        })
        .finally(() => {
          this.csvExportingId = null
        })
    },
    statToExcel (table, name) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.filterSelect
        payload.searchText = this.searchText
        payload.fromDate = this.fromDate
        payload.toDate = this.toDate
        axios.post('https://' + process.env.ROOT_API + '/munkak/getstatuslogstat', {payload})
          .then(res => {
            this.statList = res.data.stat
            console.log(res.data)
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
      }
      // if (!table.nodeType) table = this.$refs.statListTable
      // var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      // var link = document.createElement('a')
      // link.download = 'Munkalapok.xls'
      // link.href = this.uri + this.base64(this.format(this.template, ctx))
      // link.click()
    },    
    tableToExcel (table, name) {
      if (!table.nodeType) table = this.$refs.listTable
      var ctx = {worksheet: name || 'Worksheet', table: table.innerHTML}
      var link = document.createElement('a')
      link.download = 'Munkalapok.xls'
      link.href = this.uri + this.base64(this.format(this.template, ctx))
      link.click()
    },
    search () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.filter = this.filterSelect
        payload.searchText = this.searchText
        payload.fromDate = this.fromDate
        payload.toDate = this.toDate
        axios.post('https://' + process.env.ROOT_API + '/munkak/search', {payload})
          .then(res => {
            this.list = res.data
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    searchStatus () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.statusListSelect = this.statusListSelect
        payload.fromDate = this.fromDate
        payload.toDate = this.toDate
        payload.archiv = this.archiv
        axios.post('https://' + process.env.ROOT_API + '/munkak/searchstatus', {payload})
          .then(res => {
            this.list = res.data
            this.$refs.searchInput.focus()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    printPDF (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios.post('https://' + process.env.ROOT_API + '/munkak/pdf', {payload})
          .then(res => {
            this.myTempAnyagTipus = res.data.client
            if (this.myTempAnyagTipus.cikkTetels.length > 0) {
              this.EgyebTetelekShow = true
            } else { this.EgyebTetelekShow = false }
            this.$refs.html2Pdf.generatePdf()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    deleteElement: function (req) {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = req
        axios
          .post('https://' + process.env.ROOT_API + '/munkak/delete', { payload })
          .then(res => {
            this.loadList()
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    showMsgBoxTwo (id, partner) {
      this.boxTwo = ''
      this.$bvModal
        .msgBoxConfirm('(ID:' + id + ') ' + partner, {
          title: 'Biztos törlöni akarod?',
          size: 'sm',
          buttonSize: 'sm',
          okVariant: 'danger',
          okTitle: 'IGEN',
          cancelTitle: 'NEM',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: true
        })
        .then(value => {
          if (value) this.deleteElement(id)
        })
        .catch(err => {
          console.log(err)
        })
    },
    loadList () {
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        axios.post('https://' + process.env.ROOT_API + '/munkak/getlist', {payload})
          .then(res => {
            this.list = res.data
          })
          .catch(err => {
            console.log(err)
          })
        axios
          .post('https://' + process.env.ROOT_API + '/status/getlist', { payload })
          .then(res => {
            for (var el in res.data) {
              this.statusList.push(
                {
                  value: res.data[el],
                  text: res.data[el].megnevezes
                })
            }
            this.statusSelect = res.data[0]
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Munkak.vue